import _inherits from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable lodash/prefer-lodash-typecheck */
// eslint-disable-next-line max-classes-per-file
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { getGlobalSpecialsSettings } from './utilities';
var BigRoundEnums = {
  ROUND_DOWN: 0,
  ROUND_HALF_UP: 1,
  ROUND_HALF_EVEN: 2,
  ROUND_UP: 3
};
var DetailBase = /*#__PURE__*/function () {
  function DetailBase() {
    _classCallCheck(this, DetailBase);
    this.remainder = Big(0);
  }
  _createClass(DetailBase, [{
    key: "addDataValue",
    value: function addDataValue() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type,
        subtype = _ref.subtype,
        value = _ref.value,
        _ref$doNotRound = _ref.doNotRound,
        doNotRound = _ref$doNotRound === void 0 ? false : _ref$doNotRound;
      // this will round decimals to the nearest cent
      //
      // Might need to deal with remainders across the subtype of sales tax
      // that are vape taxes and the rest of sales taxes.
      var intValue = doNotRound ? value : value.round(0, BigRoundEnums.ROUND_HALF_UP);
      this[type] = this[type] || {};
      this[type][subtype] = (this[type][subtype] || Big(0)).plus(intValue);
      var remainder = value.minus(intValue);
      this[type].remainder = (this[type].remainder || Big(0)).add(remainder);
    }
  }, {
    key: "addDataArray",
    value: function addDataArray() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref2.type,
        subtype = _ref2.subtype,
        value = _ref2.value,
        id = _ref2.id,
        name = _ref2.name,
        additionalAttributes = _ref2.additionalAttributes;
      // this will round decimals to the nearest cent
      var intValue = value.round(0, BigRoundEnums.ROUND_HALF_UP);
      this[type] = this[type] || {};
      this[type][subtype] = this[type][subtype] || [];
      this[type][subtype].push(_objectSpread({
        id: id,
        name: name,
        value: intValue
      }, additionalAttributes));
      var remainder = value.minus(intValue);
      // We actually always want to add the remainder here, whether negative or positive.
      this[type].remainder = (this[type].remainder || Big(0)).add(remainder);
    }
  }, {
    key: "addTax",
    value: function addTax(_ref3) {
      var type = _ref3.type,
        value = _ref3.value;
      if (!value.eq(0)) {
        this.addDataValue({
          type: 'taxes',
          subtype: type,
          value: value
        });
      }
    }
  }, {
    key: "addFee",
    value: function addFee(_ref4) {
      var type = _ref4.type,
        value = _ref4.value;
      if (!value.eq(0)) {
        this.addDataValue({
          type: 'fees',
          subtype: type,
          value: value
        });
      }
    }
  }, {
    key: "addReward",
    value: function addReward(_ref5) {
      var type = _ref5.type,
        value = _ref5.value,
        id = _ref5.id,
        name = _ref5.name;
      if (!value.eq(0)) {
        this.addDataArray({
          type: 'rewards',
          subtype: type,
          value: value,
          id: id,
          name: name
        });
      }
    }
  }, {
    key: "addDiscount",
    value: function addDiscount(_ref6) {
      var _ref6$type = _ref6.type,
        type = _ref6$type === void 0 ? 'all' : _ref6$type,
        value = _ref6.value,
        id = _ref6.id,
        name = _ref6.name,
        _ref6$additionalAttri = _ref6.additionalAttributes,
        additionalAttributes = _ref6$additionalAttri === void 0 ? {} : _ref6$additionalAttri;
      if (!value.eq(0)) {
        this.addDataArray({
          type: 'discounts',
          subtype: type,
          value: value,
          id: id,
          name: name,
          additionalAttributes: additionalAttributes
        });
      }
    }
  }, {
    key: "addIncentive",
    value: function addIncentive(_ref7) {
      var _ref7$type = _ref7.type,
        type = _ref7$type === void 0 ? 'payment' : _ref7$type,
        value = _ref7.value,
        id = _ref7.id,
        name = _ref7.name,
        _ref7$additionalAttri = _ref7.additionalAttributes,
        additionalAttributes = _ref7$additionalAttri === void 0 ? {} : _ref7$additionalAttri;
      if (!value.eq(0)) {
        this.addDataArray({
          type: 'incentives',
          subtype: type,
          value: value,
          id: id,
          name: name,
          additionalAttributes: additionalAttributes
        });
      }
    }
  }, {
    key: "addMixAndMatch",
    value: function addMixAndMatch(_ref8) {
      var type = _ref8.type,
        value = _ref8.value;
      if (!value.eq(0)) {
        this.addDataValue({
          type: 'mixAndMatch',
          subtype: type,
          value: value
        });
      }
    }
  }, {
    key: "addRounding",
    value: function addRounding(_ref9) {
      var type = _ref9.type,
        value = _ref9.value;
      if (!value.eq(0)) {
        this.addDataValue({
          type: 'rounding',
          subtype: type,
          value: value,
          doNotRound: true
        });
      }
    }
  }, {
    key: "addRoundupForCharity",
    value: function addRoundupForCharity(_ref0) {
      var type = _ref0.type,
        value = _ref0.value;
      if (!value.eq(0)) {
        this.addDataValue({
          type: 'roundupForCharity',
          subtype: type,
          value: value,
          doNotRound: true
        });
      }
    }
  }]);
  return DetailBase;
}(); // Export this for unit tests.  It should only be used from Receipt otherwise.
export var ReceiptDetails = /*#__PURE__*/function (_DetailBase) {
  _inherits(ReceiptDetails, _DetailBase);
  var _super = _createSuper(ReceiptDetails);
  function ReceiptDetails() {
    var _this;
    _classCallCheck(this, ReceiptDetails);
    _this = _super.call(this);
    _this.details = {
      order: {},
      products: []
    };
    return _this;
  }
  _createClass(ReceiptDetails, [{
    key: "addProduct",
    value: function addProduct(productID, quantity, basePrice, option) {
      var menuPrice = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var summaryPrice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      // DetailBase is acting like "ProductDetail" here.
      var newProduct = new DetailBase();
      newProduct.id = productID;
      newProduct.quantity = quantity;
      newProduct.basePrice = basePrice;
      newProduct.option = option;
      newProduct.menuPrice = menuPrice !== null && menuPrice !== void 0 ? menuPrice : basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
      newProduct.summaryPrice = summaryPrice !== null && summaryPrice !== void 0 ? summaryPrice : basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
      newProduct.total = basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
      this.details.products.push(newProduct);
      return newProduct;
    }
  }]);
  return ReceiptDetails;
}(DetailBase);

/* New structure to hold all of the information about the order.  All values are in cents.
 * Ultimately all of the other values returned from this function will be deprecated and removed.
 *
 * For each of taxes, fees, rewards, and discounts there are a series of attributers that provide
 * a breakdown and a total attribute that is the sum of those.
 *
 * We include the taxConfig that this was developed under because tax configs change and we don't
 * have these versioned.
 */
export var Receipt = /*#__PURE__*/function (_ReceiptDetails) {
  _inherits(Receipt, _ReceiptDetails);
  var _super2 = _createSuper(Receipt);
  function Receipt(dispensary) {
    var _this2;
    _classCallCheck(this, Receipt);
    _this2 = _super2.call(this);
    _this2.summary = {
      subtotal: 0,
      taxes: 0,
      fees: 0,
      rewards: 0,
      discounts: 0,
      incentives: 0,
      mixAndMatch: 0,
      total: 0,
      rounding: 0,
      roundupForCharity: 0
    };
    _this2.specialsSettings = getGlobalSpecialsSettings(dispensary);
    _this2.taxConfig = dispensary.taxConfig;
    return _this2;
  }
  _createClass(Receipt, [{
    key: "finalize",
    value: function finalize() {
      var totalTaxes = Big(0);
      var totalFees = Big(0);
      var totalRewards = Big(0);
      var totalDiscounts = Big(0);
      var totalIncentives = Big(0);
      var totalMixAndMatch = Big(0);
      var totalRounding = Big(0);
      var totalRoundupForCharity = Big(0);
      var taxBreakdown = {};

      // eslint-disable-next-line no-restricted-syntax
      var _iterator = _createForOfIteratorHelper(this.details.products),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _product$mixAndMatch;
          var product = _step.value;
          product.taxes = product.taxes || {};
          product.taxes.total = Receipt.sumSection(product.taxes);
          totalTaxes = totalTaxes.plus(product.taxes.total).plus(product.taxes.remainder || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
          Receipt.accumulateTaxes(taxBreakdown, product.taxes);
          product.rewards = product.rewards || {};
          product.rewards.total = Receipt.sumValueSection(product.rewards);
          totalRewards = totalRewards.plus(product.rewards.total).plus(product.rewards.remainder || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
          product.discounts = product.discounts || {};
          product.discounts.total = Receipt.sumValueSection(product.discounts).plus(product.discounts.remainder || Big(0));
          // Before, we were rounding product.discount.total before adding it to the totalDiscounts.
          // This resulted in extra pennies on totalDiscounts.
          // Now, we will add the unrounded product.discount.total to totalDiscounts
          // and THEN round totalDiscounts after we have iterated through the products and have our raw total
          totalDiscounts = totalDiscounts.plus(product.discounts.total);
          product.discounts.total = product.discounts.total.round(0, BigRoundEnums.ROUND_HALF_UP);
          product.incentives = product.incentives || {};
          product.incentives.total = Receipt.sumValueSection(product.incentives).plus(product.incentives.remainder || Big(0));
          // Accumulate incentives using unrounded totals across products, then round once after iteration
          totalIncentives = totalIncentives.plus(product.incentives.total);
          product.incentives.total = product.incentives.total.round(0, BigRoundEnums.ROUND_HALF_UP);
          product.mixAndMatch = product.mixAndMatch || {};
          // because mix and match isn't following the same pattern
          // as the other line items (yet) we need to be a bit more
          // careful here checking for null or non Big()s
          totalMixAndMatch = totalMixAndMatch.plus(((_product$mixAndMatch = product.mixAndMatch) === null || _product$mixAndMatch === void 0 ? void 0 : _product$mixAndMatch.total) || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      totalTaxes = totalTaxes.plus(Receipt.sumSection(this.taxes));
      totalFees = Receipt.sumSection(this.fees);
      totalRewards = totalRewards.plus(Receipt.sumValueSection(this.rewards));
      totalDiscounts = totalDiscounts.round(0, BigRoundEnums.ROUND_HALF_UP).plus(Receipt.sumValueSection(this.discounts));
      totalIncentives = totalIncentives.round(0, BigRoundEnums.ROUND_HALF_UP).plus(Receipt.sumValueSection(this.incentives));
      totalRounding = Receipt.sumSection(this.rounding);
      totalRoundupForCharity = Receipt.sumSection(this.roundupForCharity);

      // Calculate total products before tax adjustments
      var totalProducts = _.reduce(_.map(this.details.products, function (product) {
        return product.basePrice.times(product.quantity).plus(product.remainder).round(0, BigRoundEnums.ROUND_HALF_UP);
      }), function (total, value) {
        return total.plus(value);
      }, Big(0));

      // this ensures the taxes in both the product and the order level are on the taxBreakdown,
      // this specifically happens with feeTaxes in CA where the tax is placed on the Receipt instead of the receiptDetail
      this.details.taxBreakdown = _.mergeWith({}, taxBreakdown, this.taxes, function (objValue, srcValue) {
        if (objValue && srcValue) {
          return objValue.plus(srcValue);
        }
        return undefined;
      });

      // Calculate final total by adding all components
      // Note: taxes (totalTaxes) are added here, which includes the taxes we subtracted above
      this.summary.total = totalProducts.plus(totalTaxes).plus(totalFees).minus(totalRewards).minus(totalDiscounts).minus(totalIncentives).plus(totalRounding).plus(totalRoundupForCharity);
      this.summary.subtotal = totalProducts;
      this.summary.taxes = totalTaxes;
      this.summary.fees = totalFees;
      this.summary.rewards = totalRewards;
      this.summary.discounts = totalDiscounts;
      this.summary.incentives = totalIncentives;
      this.summary.mixAndMatch = totalMixAndMatch;
      this.summary.rounding = totalRounding;
      this.summary.roundupForCharity = totalRoundupForCharity;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var rv = _.mapValues({
        specialsSettings: this.specialsSettings,
        taxConfig: this.taxConfig,
        summary: this.summary,
        details: {
          order: this.details.order,
          products: this.details.products,
          taxBreakdown: this.details.taxBreakdown
        }
      }, Receipt.toJSONMapper);
      if (!_.isNil(this.taxes)) {
        rv.details.order.taxes = _.mapValues(this.taxes, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.fees)) {
        rv.details.order.fees = _.mapValues(this.fees, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.rewards)) {
        rv.details.order.rewards = _.mapValues(this.rewards, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.discounts)) {
        rv.details.order.discounts = _.mapValues(this.discounts, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.incentives)) {
        rv.details.order.incentives = _.mapValues(this.incentives, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.mixAndMatch)) {
        rv.details.order.mixAndMatch = _.mapValues(this.mixAndMatch, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.rounding)) {
        rv.details.order.rounding = _.mapValues(this.rounding, Receipt.toJSONMapper);
      }
      if (!_.isNil(this.roundupForCharity)) {
        rv.details.order.roundupForCharity = _.mapValues(this.roundupForCharity, Receipt.toJSONMapper);
      }
      return rv;
    }
  }], [{
    key: "sumSection",
    value: function sumSection(section) {
      return _.reduce(section, function (total, value, key) {
        return total.plus(_.includes(Receipt.specialKeys, key) ? Big(0) : value);
      }, Big(0));
    }
  }, {
    key: "sumValueSection",
    value: function sumValueSection(section) {
      return _.reduce(section, function (total, value, key) {
        try {
          return total.plus(_.includes(Receipt.specialKeys, key) ? Big(0) : _.reduce(value, function (tot, val) {
            return tot.plus(val.value);
          }, Big(0)));
        } catch (e) {
          console.log(e);
          throw e;
        }
      }, Big(0));
    }
  }, {
    key: "accumulateTaxes",
    value: function accumulateTaxes(breakdown, section) {
      _.forEach(section, function (value, key) {
        if (!_.includes(Receipt.specialKeys, key)) {
          breakdown[key] = breakdown[key] || Big(0);
          breakdown[key] = breakdown[key].plus(value);
        }
      });
    }
  }, {
    key: "toJSONMapper",
    value: function toJSONMapper(value) {
      var _value$constructor;
      // Check for Big.js objects (including corrupted ones from test environments)
      var isBigLike = value instanceof Big || (value === null || value === void 0 || (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) === 'Big' && typeof value.s === 'number' && typeof value.e === 'number' && Array.isArray(value.c);
      if (isBigLike) {
        var _value$c;
        // Handle corrupted Big.js objects (when coefficient array contains objects instead of numbers)
        if (!(value instanceof Big) && (_value$c = value.c) !== null && _value$c !== void 0 && _value$c.some(function (coef) {
          return typeof coef === 'object';
        })) {
          return 0; // Safe fallback for corrupted objects
        }
        return Number(value);
      }
      if (_.isArray(value)) {
        return _.map(value, function (val) {
          return _.mapValues(val, Receipt.toJSONMapper);
        });
      }
      if (!_.isFunction(value) && Object(value) === value) {
        return _.mapValues(value, Receipt.toJSONMapper);
      }
      return value;
    }
  }]);
  return Receipt;
}(ReceiptDetails);
_defineProperty(Receipt, "specialKeys", ['total', 'remainder']);